import 'expo-router/entry';
import 'smoothie/assets/reset.css'; // A web reset. On native, all global stylesheets are automatically ignored. CSS is enabled via metro.config.js.

import { Slot } from 'expo-router';
import * as React from 'react';
import ErrorBoundary from 'react-native-error-boundary';

import AuthProvider from '../auth/providers/AuthProvider';
import UncaughtError from '../common/components/UncaughtError';
import RegisterRoutingInstrumentation from '../common/middleware/components/RegisterRoutingInstrumentation';
import { DesignSystemProvider } from '../common/providers/DesignSystemProvider';
import DataFetchingProvider from '../http/providers/DataFetchingProvider';
import { DatadogProvider } from '../logger/datadog/DatadogFacade';
import { handleUncaughtException, initLoggers } from '../logger/Logger';
import SessionManager from '../session/components/SessionManager';

initLoggers();

function RootLayout() {
    return (
        <>
            <RegisterRoutingInstrumentation>
                <DatadogProvider>
                    <DesignSystemProvider>
                        <ErrorBoundary
                            onError={handleUncaughtException}
                            FallbackComponent={UncaughtError}
                        >
                            <AuthProvider>
                                <DataFetchingProvider>
                                    <SessionManager>
                                        <Slot />
                                    </SessionManager>
                                </DataFetchingProvider>
                            </AuthProvider>
                        </ErrorBoundary>
                    </DesignSystemProvider>
                </DatadogProvider>
            </RegisterRoutingInstrumentation>
        </>
    );
}

export default RootLayout;
